import { render, staticRenderFns } from "./ResearchData.vue?vue&type=template&id=f0501bde&scoped=true&"
import script from "./ResearchData.vue?vue&type=script&lang=js&"
export * from "./ResearchData.vue?vue&type=script&lang=js&"
import style0 from "./ResearchData.vue?vue&type=style&index=0&id=f0501bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0501bde",
  null
  
)

export default component.exports